import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiembroAdminSnapshot } from '../../models/constitution-snapshot.model';
import {
  formatYesNo,
  shouldShowCargoSection,
} from '../../../constitution-form/utils/admin-display.util';
import { formatEuro, formatEuroInteger } from '../../../constitution-form/utils/socios-display.util';
import { ConstitutionReadonlyFieldComponent } from '../shared/constitution-readonly-field.component';

@Component({
  selector: 'app-constitution-administration-readonly-detail',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ConstitutionReadonlyFieldComponent],
  templateUrl: './constitution-administration-readonly-detail.component.html',
  styleUrl: '../../../constitution-form/constitution-form.component.scss',
})
export class ConstitutionAdministrationReadonlyDetailComponent {
  miembro = input.required<MiembroAdminSnapshot>();
  sistemaRaw = input<string | undefined>();

  readonly formatYesNo = formatYesNo;
  readonly formatEuro = formatEuro;

  readonly showCargoSection = computed(() => shouldShowCargoSection(this.sistemaRaw()));

  retributionKeysLabel(): string {
    const keys = this.miembro().retributionKeys ?? [];
    return keys.length > 0 ? keys.join('; ') : '—';
  }

  monthlyIncomeLabel(): string {
    return formatEuroInteger(this.miembro().monthlyNetIncome);
  }
}
